import React from 'react';
import { METRICS, money } from './revenueLogic';

/** Orange badge + amount that marks a cell's pickup revenue, so it reads as pickup and not forecast. */
export function PickupTag({ amount, compact = false, label = '$ Pickup', title }) {
  return <div style={{ color: 'var(--accent-orange)', fontWeight: 700, fontSize: 10, lineHeight: 1.2 }} title={title || `${money(amount)} post-go-live pickup (not included in the total above)`}>{label}{compact ? '' : ` ${money(amount)}`}</div>;
}

/** Hours / Revenue switch shared by the Forecasting, Baselines and Capacity views. */
export default function MetricToggle({ metric, onChange }) {
  return (
    <div className="up-grain" role="group" aria-label="Show hours or revenue" style={{ marginBottom: 12 }}>
      {METRICS.map(([k, label]) => <button key={k} className={metric === k ? 'btn btn-primary' : 'btn btn-outline'} onClick={() => onChange(k)}>{label}</button>)}
      {metric === 'revenue' && <span className="text-muted" style={{ fontSize: 12 }}>Hours × the Services billing rate in effect that month.</span>}
    </div>
  );
}
